<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<img
  class="logo"
  height="80"
  width="250"
  src="/images/logo.svg"
  alt="Sunset Grill logo">

<div class="content">
  <span class="title">Give the Gift on Breakfast!</span>
  <span class="description">Treat yourself or someone you love to<br>fresh-made breakfast or lunch.</span>
  <div class="link">
    <app-qrcode content="https://oon.gl/LQ8xY7" [size]="264"/>
    <span class="label">Buy now</span>
  </div>
</div>

